var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "path2006") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---SFY---Personalise",
    transform: "translate(-373.000000, -682.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(119.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.480299,41.2306131 L264.581605,46.4269318 L270.197376,46.8050637 L265.878087,50.3887732 L267.252802,55.8152833 L262.480299,52.8398925 L257.707795,55.8152833 L259.082511,50.3887733 L254.763222,46.8050633 L260.378993,46.4269319 L262.480299,41.2306131 Z",
    id: "path2006"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.02c36223ed471ee4f226b4fd7a74be3e.svg";
export { ForwardRef as ReactComponent };